import { render, staticRenderFns } from "./additionalnewservice.vue?vue&type=template&id=67ba30ae&scoped=true&"
import script from "./additionalnewservice.vue?vue&type=script&lang=js&"
export * from "./additionalnewservice.vue?vue&type=script&lang=js&"
import style0 from "./additionalnewservice.vue?vue&type=style&index=0&id=67ba30ae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ba30ae",
  null
  
)

export default component.exports